import type { Variant } from '@ui/types/form/item'

const variantMap: Record<Variant, string> = {
  default: 'bg-gray-100 dark:bg-gray-900',
  outlined: 'bg-transparent border-gray-300 dark:border-gray-800',
  tonal: 'bg-gray-50 border-gray-300',
  plain: 'bg-transparent border-transparent'
}

export const useVariant = (variant: Variant) => variantMap[variant]
